var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "button today",
      attrs: { "aria-label": _vm.title, title: _vm.title },
      on: {
        click: function($event) {
          return _vm.today()
        }
      }
    },
    [_vm._v("\n\t" + _vm._s(_vm.$t("calendar", "Today")) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }